import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PlatformAskAi from '../pages/features/PlatformAskAi';
import { FeaturesIcons } from '../pages/features/FeaturesIcons';
import { isPlatformAskAiPath } from '../utils/platformAskAiPath';
import { loadPlatformAskAiSession } from '../utils/platformAskAiSession';

type PlatformAskAiContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const PlatformAskAiContext = createContext<PlatformAskAiContextValue | null>(null);

export function usePlatformAskAi(): PlatformAskAiContextValue {
  const value = useContext(PlatformAskAiContext);
  if (!value) {
    return {
      open: false,
      setOpen: () => undefined,
    };
  }
  return value;
}

export const PlatformAskAiProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(() => Boolean(loadPlatformAskAiSession()?.open));
  const value = useMemo(() => ({ open, setOpen }), [open]);
  return (
    <PlatformAskAiContext.Provider value={value}>
      {children}
    </PlatformAskAiContext.Provider>
  );
};

export const PlatformAskAiHost: React.FC = () => {
  const { pathname } = useLocation();
  const { open, setOpen } = usePlatformAskAi();
  const visible = isPlatformAskAiPath(pathname);

  useEffect(() => {
    if (!visible) setOpen(false);
  }, [visible, setOpen]);

  if (!visible) return null;

  return (
    <div className="aac-platform-ask">
      <FeaturesIcons />
      <PlatformAskAi open={open} onOpenChange={setOpen} />
    </div>
  );
};
